import { Link } from 'react-router-dom'
import { Baby, TrendingUp, Calculator, Heart, Braces, ArrowUpRight, Clock, Link2, Regex, Binary, Image, FileText, Minimize2, Maximize2, FilePlus2, Scissors, Repeat, QrCode, Crop, FileImage, RefreshCw, TextCursorInput, Archive, BadgeCheck, ScanFace, Share2 } from 'lucide-react'
import { Tool } from '../types'

interface ToolCardProps {
  tool: Tool
}

const iconMap = {
  Baby,
  TrendingUp,
  Calculator,
  Heart,
  Braces,
  Clock,
  Link2,
  Regex,
  Binary,
  Image,
  FileText,
  Minimize2,
  Maximize2,
  FilePlus2,
  Scissors,
  Repeat,
  QrCode,
  Crop,
  FileImage,
  RefreshCw,
  TextCursorInput,
  Archive,
  BadgeCheck,
  ScanFace,
  Share2
}

const ToolCard: React.FC<ToolCardProps> = ({ tool }) => {
  const IconComponent = iconMap[tool.icon as keyof typeof iconMap] || Baby
  const isExternal = tool.status === 'external' && tool.externalUrl
  const card = (
    <div className="group h-full rounded-2xl border border-slate-200 bg-white p-5 transition hover:border-slate-400">
      <div className="mb-4 flex items-start justify-between gap-4">
        <IconComponent className="h-5 w-5 text-slate-700" />
        {tool.badge && (
          <span className="rounded-full bg-slate-100 px-2.5 py-1 text-xs text-slate-600">
            {tool.badge}
          </span>
        )}
      </div>

      <h3 className="mb-2 text-base font-semibold text-slate-950">{tool.name}</h3>
      <p className="min-h-[60px] text-sm leading-6 text-slate-600">{tool.description}</p>

      <div className="mt-5 flex items-center gap-1 text-sm font-medium text-slate-900">
        <span>{isExternal ? '打开看板' : '使用工具'}</span>
        <ArrowUpRight className="h-4 w-4" />
      </div>
    </div>
  )

  if (isExternal) {
    return (
      <a href={tool.externalUrl} className="block h-full">
        {card}
      </a>
    )
  }

  return (
    <Link to={tool.path} className="block h-full">
      {card}
    </Link>
  )
}

export default ToolCard
